/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // Start with stored preference, or null (means "not yet decided")
  // Start with stored preference, or detect via browser settings (instant)
  const [lang, setLangState] = useState(() => {
    try {
      const stored = localStorage.getItem('siteLang');
      if (stored === 'en' || stored === 'ge') return stored;
      
      // Since the primary target market is Georgia, and many local users have 
      // their devices set to English, it is safest to default to Georgian.
      // Users can manually switch to English using the language toggle.
      return 'ge';
    } catch {
      return 'ge';
    }
  });

  // When user explicitly picks a language, save it
  const setLang = (l) => {
    try {
      localStorage.setItem('siteLang', l);
      localStorage.setItem('siteLangChosen', '1');
    } catch {
      // ignore
    }
    setLangState(l);
  };

  // Keep html lang attribute in sync
  useEffect(() => {
    if (lang) document.documentElement.lang = lang === 'ge' ? 'ka' : 'en';
  }, [lang]);

  const activeLang = lang || 'en'; // fallback while IP fetch is in-flight

  const t = (key) => {
    const src = translations[activeLang] || translations['en'];
    return (src && src[key]) ? src[key] : key;
  };

  return (
    <LanguageContext.Provider value={{ lang: activeLang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
